import { render, staticRenderFns } from "./CoursewareBlockadderItem.vue?vue&type=template&id=36cb1759&"
import script from "./CoursewareBlockadderItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockadderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports